import { Controller } from "@hotwired/stimulus"
import { post } from "@rails/request.js"
import { isEqual, omit } from "lodash";

// Connects to data-controller="indicaciones-medicas-office"
export default class extends Controller {
  static values = {
    registro: Number,
    hoja: Number,
    currentDate: String,
    currentUser: String
  }

  initialize() {
    this.indicacionesOffice = [];
  }

  connect() {
    const savedIndicaciones = this.element.dataset.indicacionesOffice;

    if (savedIndicaciones?.length) {
      JSON.parse(savedIndicaciones).forEach(indicacionOffice => {
        const parsedIndicacion = JSON.parse(indicacionOffice)

        this.indicacionesOffice.push({
          MaterialCodigo: parsedIndicacion.MaterialCodigo,
          medicamento: parsedIndicacion.medicamento,
          Interno: parsedIndicacion.Interno,
          HoraColoc: this.extractHour(parsedIndicacion.HoraColoc),
          Fecha: parsedIndicacion.Fecha,
          Usuario: parsedIndicacion.Usuario || this.currentUserValue,
          destroyable: false,
          persisted: true
        });
      });
    }

    this.indicacionesOffice.forEach(indicacionOffice => {
      const checkbox = this.element.querySelector(`#${this.checkboxId(indicacionOffice.Interno, indicacionOffice.HoraColoc)}`)

      if (checkbox) {
        checkbox.checked = true;
      }
    })
  }

  setIndicacionOffice(e) {
    e.preventDefault();

    const indicacionMedicaDetalle = JSON.parse(e.target.dataset.indicacionMedicaDetalle);
    const indicacionMedicaOffice = {
      MaterialCodigo: indicacionMedicaDetalle.MaterialCodigo,
      medicamento: indicacionMedicaDetalle.medicamento,
      Interno: indicacionMedicaDetalle.Interno,
      HoraColoc: this.normalizeHour(e.target.value),
      Usuario: this.currentUserValue,
      Fecha: this.currentDateValue,
      destroyable: !e.target.checked,
      persisted: false
    }

    const indicacionOfficeIndex = this.indicacionesOffice.findIndex(ind => this.sameIndicacionOffice(ind, indicacionMedicaOffice));

    if (e.target.checked) {
      if (indicacionOfficeIndex > -1) {
        this.indicacionesOffice[indicacionOfficeIndex] = {
          ...this.indicacionesOffice[indicacionOfficeIndex],
          ...indicacionMedicaOffice,
          destroyable: false
        };
      } else {
        this.indicacionesOffice.push({ ...indicacionMedicaOffice, destroyable: false });
      }

      return;
    }

    if (indicacionOfficeIndex === -1) {
      return;
    }

    if (this.indicacionesOffice[indicacionOfficeIndex].persisted) {
      this.indicacionesOffice[indicacionOfficeIndex].destroyable = true;
    } else {
      this.indicacionesOffice.splice(indicacionOfficeIndex, 1);
    }
  }

  submit(e) {
    e.preventDefault();

    post('/indicaciones_medicas_office/batch_create', {
      responseKind: 'turbo-stream',
      body: {
        Registro: this.registroValue,
        Hoja: this.hojaValue,
        current_date: this.currentDateValue,
        indicaciones_medicas_office: this.indicacionesOffice.map(indicacionOffice => omit(indicacionOffice, ['persisted']))
      }
    })
  }

  checkboxId(interno, horaColoc) {
    return `indicaciones-office-${interno}-${this.normalizeHour(horaColoc)}`
  }

  normalizeHour(hour) {
    return hour.toString().padStart(2, '0')
  }

  extractHour(horaColoc) {
    if (typeof horaColoc === 'string') {
      const matchedHour = horaColoc.match(/(?:T|\s)(\d{2}):\d{2}:\d{2}|^(\d{2}):\d{2}:\d{2}$/)

      if (matchedHour) {
        return matchedHour[1] || matchedHour[2]
      }
    }

    return this.normalizeHour(new Date(horaColoc).getHours())
  }

  sameIndicacionOffice(currentIndicacion, nextIndicacion) {
    return isEqual(
      omit(currentIndicacion, ['Usuario', 'destroyable', 'persisted', 'MaterialCodigo', 'medicamento']),
      omit(nextIndicacion, ['Usuario', 'destroyable', 'persisted', 'MaterialCodigo', 'medicamento'])
    )
  }
}
